import React from 'react';

export function useLayerSize(activeProjectionRows: number) {
  const layerRef = React.useRef<HTMLDivElement | null>(null);
  const [layerSize, setLayerSize] = React.useState({ width: 0, height: 0 });

  React.useEffect(() => {
    const node = layerRef.current;
    if (!node) return;
    const updateSize = () => {
      const layoutWidth = node.offsetWidth;
      const layoutHeight = node.offsetHeight;
      const rect = node.getBoundingClientRect();
      const width = layoutWidth > 0 ? layoutWidth : rect.width;
      const height = layoutHeight > 0 ? layoutHeight : rect.height;
      setLayerSize((current) =>
        current.width === width && current.height === height
          ? current
          : { width, height }
      );
    };
    updateSize();
    if (typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver(() => updateSize());
    observer.observe(node);
    return () => observer.disconnect();
  }, [activeProjectionRows]);

  return { layerRef, layerSize };
}
